














import { computed, defineComponent } from '@vue/composition-api';
import { useNewProjectsStore } from '@/stores/new-project';
import { useMasterDataStore } from '@/stores/master-data';

export default defineComponent({
  name: 'PhpVersion',
  props: {},
  setup() {
    const newProjectsStore = useNewProjectsStore();
    const masterDataStore = useMasterDataStore();
    const availableRuntimeVersions = computed<string[]>(() => masterDataStore.phpVersions);

    const defaultPhpVersion = computed<string | undefined>({
      get() {
        return newProjectsStore.defaultPhpVersion;
      },
      set(value) {
        newProjectsStore.setDefaultPhpVersion(value);
      },
    });

    if (newProjectsStore.defaultPhpVersion === undefined) {
      const lastPhpVersion = masterDataStore.phpVersions.slice(-1)[0];
      newProjectsStore.setDefaultPhpVersion(lastPhpVersion);
    }

    return {
      availableRuntimeVersions,
      defaultPhpVersion,
    };
  },
});
